import { SnackbarOrigin } from '@mui/material';
import { StatusEnum } from 'components/components/MBSnackbar';

export enum SnackbarMessageType {
  ALL_ITEMS_ADDED_TO_CART = 'allItemsAddedToCart',
  ALL_ITEMS_ADDED_TO_CART_EXCEPT_FINISHES = 'allItemsAddedToCartExceptFinishes',
}

export interface SnackbarMessagePayload extends Record<string, any> {}

export interface SnackbarInfo {
  anchorOrigin?: SnackbarOrigin;
  isOpen: boolean;
  message?: string;
  messagePayload?: SnackbarMessagePayload;
  messageType?: SnackbarMessageType;
  photo?: string;
  status?: StatusEnum;
}
